import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import { useSelector } from 'react-redux';
import InfoBlock from '../../InfoBlock';
import CarRateDetailDropdownPopover from '../../TravelOption/CarsInformation/CarItinerary/CarRateDetailDropdownPopover/index.tsx';
import checkDoShowMarkupRates from '../../../helpers/selectors/checkDoShowMarkupRates';
import { TravelTypes } from '../../../constants';
import { useMemo } from 'react';
import formatCarMileageAllowance from '../../../helpers/formatters/formatCarMileageAllowance.js';

dayjs.extend(dayjsPluginUTC);

const RentalCarInfo = ({ itinerary, tripId }) => {
  const doShowMarkupRates = useSelector(
    checkDoShowMarkupRates({
      mode: TravelTypes.carrental,
      tripId,
    }),
  );

  const mileageAllowance = useMemo(() => {
    return formatCarMileageAllowance(itinerary);
  }, [itinerary]);

  return (
    <InfoBlock title="Rental details">
      <div className="grid grid-cols-2 text-sm">
        <div>Pickup location:</div>
        <div>{itinerary.locationInfo.pickUpAddress}</div>
        <div>Pickup date/time:</div>
        <div>{dayjs(itinerary.pickUpDateTime).format('ddd D MMM, YYYY hh:mma')}</div>
        <div>Dropoff location:</div>
        <div>{itinerary.locationInfo.dropOffAddress}</div>
        <div>Dropoff date/time:</div>
        <div>{dayjs(itinerary.dropOffDateTime).format('ddd D MMM, YYYY hh:mma')}</div>
        <div>Agency:</div>
        <div>{itinerary.bookingProviderInfo.agent}</div>

        {mileageAllowance && (
          <>
            <div>Mileage allowance:</div>
            <div>{mileageAllowance}</div>
          </>
        )}
        {itinerary && itinerary.priceInfo && (
          <>
            <div>&nbsp;</div>
            <div>
              <CarRateDetailDropdownPopover
                dropdownLabel="Price detail"
                fontSize="text-sm"
                alignClass="justify-left"
                popoverAlignClass="right-0"
                priceInfo={itinerary.priceInfo}
                doShowMarkupRate={doShowMarkupRates}
              />
            </div>
          </>
        )}
      </div>
    </InfoBlock>
  );
};

RentalCarInfo.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string.isRequired,
};

export default RentalCarInfo;
